import React, {Component} from 'react';

import { MainHeader, MainFooter } from '../Components';

class PageHostingTerms extends Component {
    render() {
        return ( 
            <div className="App">
                <MainHeader user={this.props.user}/>
                <section className="section is-medium">
                    <div className="container">
                        <div className="content">
                            <h4 className="title is-size-4">ข้อกำหนดในการให้บริการของ Ling Hosting (Alpha)</h4>
                            <p>แก้ไขล่าสุดวันที่ 10 ตุลาคม 2018</p>
                            <p>คุณจะต้องยอมรับข้อกำหนดเหล่านี้เพื่อใช้งาน Ling Hosting</p>
                            <ol>
                                <li>
                                    การใช้งาน Ling Hosting
                                    <ul>
                                        <li>
                                            ข้อจำกัดด้านอายุ เพื่อใช้งาน Ling Hosting  คุณต้องมีอายุ 13 ปีขึ้นไป หากคุณอายุ 13 ปีขึ้นไปแต่ต่ำกว่า 18 ปี คุณจะต้องได้รับอนุญาตจากพ่อแม่หรือผู้ปกครองตามกฎหมายเพื่อใช้งาน Ling Hosting และเพื่อยอมรับข้อกำหนดเหล่านี้
                                        </li>
                                    </ul>
                                </li>
                                <li>
                                    บริการ Ling Hosting
                                    <ul>
                                        <li>
                                            เนื่องจากตอนนี้เป็นช่วงในการทดสอบระบบ โปรดรับรู้ว่าบริการนี้อาจไม่เสถียร
                                        </li>
                                        <li>
                                            เมื่อคุณอัปโหลด จัดเก็บ ส่ง หรือรับเนื้อหาถือว่าคุณให้สัญญาอนุญาตให้ Ling  มีสิทธิ์ใช้ โฮสต์ จัดเก็บ ทำซ้ำ แก้ไข 
                                        </li>
                                        <li>
                                            สิทธิ์ที่คุณให้ในสัญญาอนุญาตนี้เป็นไปเพื่อวัตถุประสงค์อันจำกัดในการดำเนินการ การโปรโมต และการปรับปรุงบริการของเรา และเพื่อพัฒนาบริการใหม่ๆ
                                        </li>
                                        <li>
                                            สัญญาอนุญาตนี้จะมีผลต่อไปแม้คุณจะหยุดใช้บริการแล้ว เว้นแต่คุณจะลบเนื้อหาออก โปรดตรวจสอบว่าคุณมีสิทธิ์ที่จำเป็นในการให้สัญญาอนุญาตนี้แก่เราสำหรับเนื้อหาใดๆ ที่คุณส่งไปยัง Ling Hosting
                                        </li>
                                    </ul>
                                </li>
                                <li>
                                    การเลิกใช้บริการ
                                    <ul>
                                        <li>
                                            การหยุดให้บริการ Ling Hosting เราตัดสินใจหยุดให้บริการ Ling Hosting เราจะแจ้งให้ทราบล่วงหน้าอย่างน้อย 60 วัน โดยในระหว่างเวลานี้คุณจะมีเวลานำไฟล์ของคุณออกจาก Ling Hosting หลังจากสิ้นสุดระยะเวลา 60 วันแล้ว คุณจะเข้าถึงไฟล์ไม่ได้อีก
                                        </li>
                                    </ul>
                                </li>
                                <li>
                                    การซื้อพื้นที่เก็บข้อมูลเพิ่มและการชำระเงิน
                                    <ul>
                                        <li>
                                            พื้นที่เก็บข้อมูลฟรี Ling Hosting อนุญาตให้คุณใช้พื้นที่เก็บข้อมูลออนไลน์ได้ฟรี 1 GB  (หากต้องการพื้นที่เก็บข้อมูลเพิ่มเติมกรุณาติดต่อพนักงาน)
                                        </li>
                                    </ul>
                                </li>
                                <li>
                                    การรับประกันและข้อจำกัดความรับผิดชอบของเรา
                                    <ul>
                                        <li>
                                            เราให้บริการ  Ling Hosting ด้วยทักษะและความเอาใจใส่ในระดับที่มีมาตรฐาน และหวังว่าคุณจะได้รับความสะดวกสบายในการใช้ ฟรี Ling Hosting แต่มีบางเรื่องที่ เราไม่สามารถให้สัญญาได้ใน  Ling Hosting นอกเหนือจากสิ่งที่กล่าวไว้โดยชัดแจ้ง
                                        </li>
                                        <li>
                                            เราไม่ให้คำมั่นสัญญาเกี่ยวกับการทำงานในด้านใดด้านหนึ่งโดยเฉพาะผ่าน Ling Hosting รวมถึงความเชื่อถือได้ การพร้อมให้บริการหรือความสามารถในการตอบสนองความต้องการของคุณ (เนื่องจากอยู่ในช่วงการทดสอบระบบ)
                                        </li>
                                    </ul>
                                </li>
                                <li>
                                    ความรับผิดสำหรับ Ling Hosting
                                    <ul>
                                        <li>
                                            ความสูญเสียหรือความเสียหายใดๆ ซึ่งในขณะที่คุณยอมรับสัญญาที่เกี่ยวข้อง ไม่ใช่เป็นผลที่ควรคาดการณ์ได้ล่วงหน้าจากการที่ Ling Hosting ละเมิดข้อกำหนด หรือความสูญเสียที่เกี่ยวข้องกับธุรกิจของคุณ รวมถึงการสูญเสียกำไร รายได้ โอกาสหรือข้อมูล (เนื่องจากอยู่ในช่วงการทดสอบระบบ)
                                        </li>
                                    </ul>
                                </li>
                            </ol>
                        </div>
                    </div>
                </section>
                <MainFooter />
            </div>
        )
    }
}

export default PageHostingTerms;


// WEBPACK FOOTER //
// ./src/PageHostingTerms/PageHostingTerms.js